import { TFunction } from "i18next";

/** API state → i18n key under delivery.logisticStates */
export const LOGISTIC_STATE_I18N_KEYS: Record<string, string> = {
  NOT_CREATED: "delivery.logisticStates.notCreated",
  notCreated: "delivery.logisticStates.notCreated",
  CALCULATED: "delivery.logisticStates.pendingPayment",
  calculated: "delivery.logisticStates.pendingPayment",
  CREATED: "delivery.logisticStates.created",
  created: "delivery.logisticStates.created",
  ASSIGNED: "delivery.logisticStates.assigned",
  assigned: "delivery.logisticStates.assigned",
  PENDING_PAYMENT: "delivery.logisticStates.pendingPayment",
  pendingPayment: "delivery.logisticStates.pendingPayment",
  pending_payment: "delivery.logisticStates.pendingPayment",
  SUCCESS_PAYMENT: "delivery.logisticStates.successPayment",
  successPayment: "delivery.logisticStates.successPayment",
  success_payment: "delivery.logisticStates.successPayment",
  IN_PROGRESS: "delivery.logisticStates.inProgress",
  inProgress: "delivery.logisticStates.inProgress",
  in_progress: "delivery.logisticStates.inProgress",
  FINISHED: "delivery.logisticStates.finished",
  finished: "delivery.logisticStates.finished",
  ERROR: "delivery.logisticStates.error",
  error: "delivery.logisticStates.error",
  pending: "delivery.logisticStates.pending",
  cancelled: "delivery.logisticStates.cancelled",
  CANCELLED: "delivery.logisticStates.cancelled",
};

const CANCELLED_SUB_STATES = new Set([
  "CANCELLED",
  "cancelled",
  "LOGISTIC_ERROR",
  "logisticError",
]);

/** @deprecated Use resolveLogisticStateLabel */
export const LOGISTIC_STATES: Record<string, string> = LOGISTIC_STATE_I18N_KEYS;

export const resolveLogisticStateLabel = (
  state: string | undefined,
  subState: string | undefined,
  t: TFunction
): string => {
  const normalizedState = state || "pending";

  if (
    (normalizedState === "ERROR" || normalizedState === "error") &&
    subState &&
    CANCELLED_SUB_STATES.has(subState)
  ) {
    return t("delivery.logisticStates.cancelled");
  }

  const key =
    LOGISTIC_STATE_I18N_KEYS[normalizedState] ||
    LOGISTIC_STATE_I18N_KEYS[normalizedState.toUpperCase()] ||
    "delivery.logisticStates.pending";

  return t(key);
};

export const CREATE_ORDER_LOGISTIC_EVENT = "CREATE_ORDER_LOGISTIC";
